import { Screen } from '~/screens/clients';

export const ClientsIndex: React.FC = () => <Screen />;
